export default __webpack_public_path__ + "dist/media/Reports.31b92bf3.svg";